import axios from 'axios';

import { baseUrl } from './index';

export const getDonationData = () => {
  return axios.get(`${baseUrl}/donation-data`);
};

export const getRemoteConfig = () => {
  return axios.get(`${baseUrl}/app/remote-config`);
};

export const sendUninstallReasons = (data: {
  reasons: {
    id: number;
    label: string;
  }[];
  message: string;
}) => {
  return axios.put(`${baseUrl}/app/uninstall`, data);
};

export const sendDeleteAccountRequest = (data: {
  reasons: {
    id: number;
    label: string;
  }[];
  message: string;
}) => {
  return axios.delete(`${baseUrl}/user`, { data });
};

export const sendContactMail = (form: {
  name: string;
  email: string;
  message: string;
}) => {
  return axios.put(`${baseUrl}/mail/contact/`, form);
};
